import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "modal-title" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "modal-footer" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal",
    id: _ctx.id,
    tabindex: "-1",
    role: "dialog"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            class: "close",
            "data-dismiss": "modal",
            "aria-label": "Close",
            onClick: _cache[0] || (_cache[0] = (...args) => ($options.hide && $options.hide(...args)))
          }, _hoisted_6),
          _createElementVNode("h4", _hoisted_7, _toDisplayString(this.modalTitle == null || this.modalTitle == '' ? '模态框' : this.modalTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-default",
            "data-dismiss": "modal",
            onClick: _cache[1] || (_cache[1] = (...args) => ($options.hide && $options.hide(...args)))
          }, _toDisplayString(this.closeName == null || this.closeName == '' ? '关闭' : this.closeName), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = (...args) => ($options.submit && $options.submit(...args)))
          }, _toDisplayString(this.confirmName == null || this.confirmName == '' ? '确认' : this.confirmName), 1)
        ])
      ])
    ])
  ], 8, _hoisted_1))
}